var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(
            _vm._s(
              _vm.$t("__.Crud.devolucaoCompra.list_vue_html.devolucaoCompra")
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "info-panel" }, [
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "__.Crud.devolucaoCompra.list_vue_html.devolucaoCompra"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("__.Crud.devolucaoCompra.list_vue_html.cadastrados")
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("grid-component", {
        ref: "gridcomponent",
        attrs: {
          columns: _vm.gridColumns,
          conditionShowSubData: _vm.conditionShowSubData,
          data: _vm.gridData,
          extraActions: _vm.extraActions,
          "page-index": _vm.pageIndex,
          "page-size": _vm.pageSize,
          showAddNewButton: false,
          showEditItem: false,
          showExpand: true,
          showRemoveItem: false,
          subColumns: _vm.gridItemColumns,
          subDataName: _vm.subDataName,
          tituloPagina: _vm.$t(
            "__.Crud.devolucaoCompra.list_vue_html.devolucaoCompra"
          ),
          total: _vm.total,
        },
        on: {
          "gerar-xls": function ($event) {
            _vm.pags = true
            _vm.tipoDocGerar = 0
          },
          "gerar-pdf": function ($event) {
            _vm.pags = true
            _vm.tipoDocGerar = 1
          },
          "gerar-impressao": function ($event) {
            _vm.pags = true
            _vm.tipoDocGerar = 2
          },
          "change-filter-key": _vm.onChangeFilterKey,
          "change-page": _vm.onChangePage,
          "change-sort": _vm.onChangeSort,
          "extra-action": _vm.onExtraAction,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }